import AimSetting from '../aimSetting';

export default function AimSettingPage() {
  return (
    <AimSetting />
  );
}
